/* eslint-disable @blumintinc/blumint/extract-global-constants */
import { CheckInProvider } from 'src/components/tournaments/check-in/CheckInContext';
import { useWizardDialog } from '../../../hooks/wizard/useWizardDialog';
import { EntryDialog } from 'src/components/tournaments/check-in/EntryDialog';
import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';
import { Competition } from 'functions/src/types/firestore/Game/Competition';
import { CheckedInDialog } from 'src/components/tournaments/check-in/CheckedInDialog';
import { CreateUsernameDialog } from 'src/components/tournaments/check-in/CreateUsernameDialog';
import { RulesCheckInDialog } from 'src/components/tournaments/check-in/RulesCheckInDialog';
import { UnregisterGuardDialog } from 'src/components/tournaments/check-in/UnregisterGuardDialog';
import { UnregisteredDialog } from 'src/components/tournaments/check-in/UnregisteredDialog';
import { Optional } from 'utility-types';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';

export type CheckInProps = Optional<
  Pick<Competition<Date>, 'gameTitle' | 'prize' | 'title' | 'date'>,
  'prize'
> &
  Pick<Tournament<Date>, 'readyTime'> & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkedIn: boolean;
    rulesAndRegulations?: string;
    isCaptain: boolean;
    teammates: Member[];
    tournamentId: string;
    teamId: string;
    gameId: string;
    preventBackdropClick?: boolean;
  };

export type CheckInStore = {
  rulesAccepted: boolean;
};

export function useCheckInDialog() {
  const { open: openWizardDialog } = useWizardDialog();

  // eslint-disable-next-line no-shadow
  const open = (props: CheckInProps) => {
    const storeDefault: CheckInStore = {
      rulesAccepted: false,
    };

    openWizardDialog({
      storeDefault,
      elements: {
        EntryDialog: <EntryDialog />,
        CreateUsernameDialog: <CreateUsernameDialog />,
        RulesCheckInDialog: <RulesCheckInDialog />,
        CheckedInDialog: <CheckedInDialog />,
        UnregisterGuardDialog: <UnregisterGuardDialog />,
        UnregisteredDialog: <UnregisteredDialog />,
      },
      elementIdEntry: 'EntryDialog',
      Wrapper: <CheckInProvider {...props} />,
      wrapperProps: {
        preventBackdropClick: true,
      },
    });
  };

  return { open };
}
